var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-content-checkbox spread"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',[_c('div',{staticClass:"container",on:{"click":function($event){return _vm.clickOptions(index)}}},[_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(item.name))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }